// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"Form__formContainer___1GA3x","formSection":"Form__formSection___1PPvW","formField":"Form__formField___38Ikl","formRow":"Form__formRow___2mwRs"};


// WEBPACK FOOTER //
// webpack://aws_amplify_ui/src/Form.css?0c1e